const selectors = {
  videoMedia: '.js-video-media',
  video: 'video',
  playPauseBtn: '.js-button-video',
  muteBtn: '.js-button-mute'
}

export default () => {
  const handleVideoButton = () => {
    const videoMediaEls = document.querySelectorAll(selectors.videoMedia)

    videoMediaEls.length && videoMediaEls.forEach(videoMediaEl => {
      const videoEl = videoMediaEl.querySelector(selectors.video);
      const buttonPlayPause = videoMediaEl.querySelector(selectors.playPauseBtn)
      const buttonMute = videoMediaEl.querySelector(selectors.muteBtn)
      if (videoEl && buttonPlayPause) {
        buttonPlayPause.addEventListener('click', (e) => {
          e.preventDefault()

          if (videoEl.paused) {
            playVideo(videoEl, buttonPlayPause)
          } else {
            pauseVideo(videoEl, buttonPlayPause)
          }

          buttonPlayPause.setAttribute('aria-pressed', 'true')

          setTimeout(function (){
            buttonPlayPause.setAttribute('aria-pressed', 'false')
          }, 500)
        })
      }
      if (videoEl && buttonMute) {
        buttonMute.addEventListener('click', (e) => {
          e.preventDefault()

          if (videoEl.muted) {
            unmuteVideo(videoEl)
          } else {
            muteVideo(videoEl)
          }

          buttonMute.setAttribute('aria-pressed', 'true')

          setTimeout(function (){
            buttonMute.setAttribute('aria-pressed', 'false')
          }, 500)
        })
      }
    });
  }

  const pauseVideo = (video, button) => {
    video.pause()
    button.classList.remove('played')
  }

  const playVideo = (video, button) => {
    video.play()
    button.classList.add('played')
  }

  const muteVideo = (video) => {
    video.muted = true
    video.classList.add('muted')
  }

  const unmuteVideo = (video) => {
    video.muted = false
    video.classList.remove('muted')
  }

  document.addEventListener("DOMContentLoaded", handleVideoButton)
}